import { Controller } from '@hotwired/stimulus'

// An in-place prompt laid over its container: makes the content beside it inert
// and keeps Tab cycling within the prompt, takes focus, and removes itself when
// dismissed.
export default class extends Controller {
  static targets = ['focus']

  connect() {
    const container = this.element.parentElement
    this.inertSiblings = [...container.parentElement.children].filter((el) => el !== container && !el.inert)
    this.inertSiblings.forEach((el) => { el.inert = true })

    if (this.hasFocusTarget) this.focusTarget.focus()
  }

  disconnect() {
    this.inertSiblings.forEach((el) => { el.inert = false })
  }

  trapFocus(event) {
    if (event.key !== 'Tab') return

    const focusable = [...this.element.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled])')]
    const edge = event.shiftKey ? focusable[0] : focusable.at(-1)
    if (document.activeElement !== edge) return

    const wrapTo = event.shiftKey ? focusable.at(-1) : focusable[0]
    event.preventDefault()
    wrapTo.focus()
  }

  dismiss() {
    this.element.remove()
  }
}
